import { useState, useCallback, useEffect } from "react";

const TOUR_STORAGE_PREFIX = "checkmaty-tour";
const TOUR_EVENT_PREFIX = "checkmaty-tour";

function buildKeys(tourId: string) {
  return {
    storageKey: `${TOUR_STORAGE_PREFIX}-${tourId}-completed`,
    eventKey: `${TOUR_EVENT_PREFIX}-${tourId}-start`,
  };
}

export function useTourState(tourId: string = "app") {
  const { storageKey, eventKey } = buildKeys(tourId);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    const handler = () => setIsRunning(true);
    window.addEventListener(eventKey, handler);
    return () => window.removeEventListener(eventKey, handler);
  }, [eventKey]);

  const hasCompletedTour = useCallback((): boolean => {
    try {
      return localStorage.getItem(storageKey) === "true";
    } catch {
      return false;
    }
  }, [storageKey]);

  const completeTour = useCallback(() => {
    try {
      localStorage.setItem(storageKey, "true");
    } catch {
      // localStorage not available
    }
    setIsRunning(false);
  }, [storageKey]);

  const resetTour = useCallback(() => {
    try {
      localStorage.removeItem(storageKey);
    } catch {
      // localStorage not available
    }
  }, [storageKey]);

  const startTour = useCallback(() => {
    window.dispatchEvent(new Event(eventKey));
  }, [eventKey]);

  const stopTour = useCallback(() => {
    setIsRunning(false);
  }, []);

  return {
    isRunning,
    hasCompletedTour,
    completeTour,
    resetTour,
    startTour,
    stopTour,
  };
}
